import update from 'react-addons-update';
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import Order18AddPhotoComponent from './Order18AddPhotoComponent';
import {
  addOrderImage,
  updateOrderDetailInfoAction,
} from '../../../actions/order';
import {
  setIsShowSimpleMessageDialog,
  setSimpleMessage,
} from '../../../actions/dialog';

import imgQuestion from '../../../assets/img/icon_question.png';
import imgQuestion2 from '../../../assets/img/icon_question@2x.png';

class Order18AddPhoto extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    addOrderImage: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    setIsShowSimpleMessageDialog: PropTypes.func.isRequired,
    setSimpleMessage: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      imageComponent: [],
      index: 0,
      /* eslint-disable react/no-unused-state */
      // for otheres component used
      isImgTooLarge: false,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      isShowLargeTag: false,
    };
    this.addImageComponent = this.addImageComponent.bind(this);
    this.removeImageComponent = this.removeImageComponent.bind(this);
    // need this function to fix
    this.setIsImgTooLarge = this.setIsImgTooLarge.bind(this);
  }

  onClickQuestionButton() {
    this.props.setSimpleMessage({
      header: this.props.modelDataText.order.item_fit_headline,
      body: this.props.modelDataText.order.item_fit_content,
    });
    this.props.setIsShowSimpleMessageDialog();
  }

  setIsImgTooLarge(bool) {
    this.setState({ isImgTooLarge: bool });
  }

  addImageComponent(isFromAddButton) {
    // first add image
    if (isFromAddButton) {
      if (this.props.images.length < 1) {
        this.state.imageComponent.push(
          <Order18AddPhotoComponent
            key={`${this.props.images.length} ${new Date().toISOString()}`}
            addImageComponent={this.addImageComponent}
            removeImageComponent={this.removeImageComponent}
            index={this.props.images.length}
            setIsImgTooLarge={this.setIsImgTooLarge}
          />,
        );
        this.props.addOrderImage({});
        this.setState({ index: this.state.index + 1 });
      }
      this.setIsImgTooLarge(true);
    } else if (this.props.images.length <= 10) {
      this.state.imageComponent.push(
        <Order18AddPhotoComponent
          key={`${this.props.images.length} ${new Date().toISOString()}`}
          addImageComponent={this.addImageComponent}
          removeImageComponent={this.removeImageComponent}
          index={this.props.images.length - 1}
          setIsImgTooLarge={this.setIsImgTooLarge}
        />,
      );
      this.setState({ index: this.state.index + 1 });
    }
    this.setState({ isShowLargeTag: true });
  }
  removeImageComponent(index) {
    this.setState({
      imageComponent: update(this.state.imageComponent, {
        $splice: [[index, 1]],
      }),
    });
  }

  render() {
    return (
      <div>
        <br />
        <Row>
          <Col
            md={{ size: 6 }}
            xs="12"
            className={s2.addPhotoButton}
            role="button"
            tabIndex={0}
            onClick={() => {
              this.addImageComponent(true);
            }}
            onKeyPress={() => {}}
          >
            <span className={`${s2.functionIcon}`} />
            <span className={`${s2.functionText}`}>
              {this.props.modelDataText.order.order_add_image_button}
            </span>
            {this.state.isShowLargeTag ? (
              <span className={s2.orderSmallTitle}>
                {this.props.modelDataText.order.order_add_image_max_size_desc}
              </span> /* gogovan website no show */
            ) : (
              ''
            )}
          </Col>
          {['kr', 'sg'].includes(this.state.lang) ? (
            <Col
              md={{ size: 'auto', offset: 6 }}
              xs="12"
              className={`${s2.addPhotoButton} ${s2.functionText}`}
              role="button"
              tabIndex={0}
              onClick={() => {
                this.onClickQuestionButton();
              }}
              onKeyPress={() => {}}
            >
              <img
                srcSet={`${imgQuestion} 1x, ${imgQuestion2} 2x`}
                height="18"
                alt="question"
              />
              {
                this.props.modelDataText.order
                  .order_will_my_item_fit_into_the_vehicle
              }
            </Col>
          ) : (
            ''
          )}
        </Row>
        <Row className={s2.uiImageUpload}>
          <span className={s2.uiImageTopOffset}>
            {this.state.imageComponent}
          </span>
        </Row>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  images: state.order.images,
});
const mapDispatch = {
  addOrderImage,
  updateOrderDetailInfoAction,
  setIsShowSimpleMessageDialog,
  setSimpleMessage,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order18AddPhoto),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order18AddPhoto/Order18AddPhoto.js